module.exports = __webpack_public_path__ + "img/Pegasus.cbe5f61a.png";